<template>
    <div class="report-list">
        <van-search v-if="!hideSearch" v-model="req.reportDes" placeholder="搜索报备说明" @search="onSearch" />
        <van-tabs v-model="currentTab" @change="onChangeTab" line-width="30px" color="#2FD0D5" sticky>
            <van-tab v-for="(it, i) in tabs" :key="i" :name="it.dictValue">
                <template #title>
                    <span>{{ it.dictLabel }}</span>
                    <span v-if="statusNum[it.dictValue]">({{ statusNum[it.dictValue] }})</span>
                </template>
            </van-tab>
        </van-tabs>
        <div class="report-list-box">
            <van-pull-refresh v-model="isLoading" @refresh="init">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
                    <div class="report-item" v-for="(it, i) in reportList" :key="i">
                        <div class="item-hd">
                            <div>申请时间：{{ it.createDate }}</div>
                            <div class="item-status" :class="it.reportStatus < 3 ? 'red' : it.reportStatus === 3 ? 'blue' : ''">{{ it.reportStatusStr }}</div>
                        </div>
                        <div class="item-ct">
                            <span>报备类型</span>
                            <span>{{ it.reportTypeStr }}</span>
                        </div>
                        <div class="item-ct">
                            <span>生效时间</span>
                            <span>{{ it.startDate }} 至 {{ it.endDate }} </span>
                        </div>
                        <div class="item-ct">
                            <span>报备说明</span>
                            <span>{{ it.reportDes }}</span>
                        </div>
                        <div class="item-btn-box">
                            <div class="item-btn" @click="onView(it)">查看详情</div>
                        </div>
                    </div>

                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import { reportPage, getDictList, getStatusNum } from '@/api/crm'

    import { throttle } from 'lodash';
    export default {
        name: 'ReportList',
        props: {
            hideSearch: {
                type: Boolean,
                default: false
            },
            storeNo: {
                type: String,
                default: ''
            },
            storeName: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                tabs: [],
                // 当前选中的tab，默认全部
                currentTab: '',
                // 下刷新
                isLoading: false,
                // 列表加载状态
                loading: false,
                // 列表数据是否全部加载完成
                finished: false,
                error: false,
                // 请求参数
                req: {
                    reportDes: '',
                    page: 1, // 当前页码
                    limit: 10, // 每页条数
                },
                reportList: [],
                // 状态数量
                statusNum: {},
            }
        },
        created() {
            this.init()
            this.getTabs()
        },
        methods: {
            async getTabs() {
                const { data } = await getDictList('report_status')
                this.tabs = [{ dictLabel: '全部', dictValue: '' }, ...data]
            },
            // 状态数量
            async getStatusNum() {
                try {
                    const req = { storeNo: this.storeNo }

                    const { code, data, msg } = await getStatusNum(req)
                    if (code !== 0) throw msg

                    this.statusNum = data[0]
                } catch (error) {
                    this.$toast(error + '')
                }
            },

            onSearch() {
                this.init()
            },
            init() {
                this.req.page = 1
                this.finished = false
                this.getStatusNum()
                this.getReportList()
            },
            onChangeTab() {
                this.init()
            },
            onLoad() {
                this.getReportList()
            },
            // 分页查询列表
            getReportList: throttle(async function () {
                this.error = false;
                if (this.finished) return
                try {
                    const req = {
                        ...this.req,
                        reportStatus: this.currentTab,
                        storeNo: this.storeNo
                        // storeNo: 'BF101010' //测试门店
                    }

                    const { code, data, msg } = await reportPage(req)
                    if (code !== 0) throw msg

                    const list = data.list || []

                    this.reportList = this.req.page === 1 ? list : [...this.reportList, ...list]

                    if (req.page * req.limit >= data.total) {
                        this.finished = true;
                    }
                    this.req.page += 1

                } catch (error) {
                    this.error = true;
                    this.$toast(error + '')
                } finally {
                    this.isLoading = false;
                    this.loading = false;
                }
            }, 1000),

            onView(it) {
                const path = it.reportStatus === 1 ? `/CRM/reportAdd?type=edit&id=${it.id}&storeNo=${this.storeNo}&storeName=${this.storeName}` : `/CRM/reportDetails?id=${it.id}&storeNo=${this.storeNo}&storeName=${this.storeName}`
                this.$router.push(path)
            },

        }
    }
</script>

<style lang='less' scoped>
    .report-list {
        height: 100%;
    }

    .report-list-box {
        height: calc(100% - 112px);
        padding: 30px;
        overflow-y: scroll;
    }

    .red {
        color: #F65252;
    }

    .blue {
        color: #2FD0D5;
    }

    .report-item {
        padding-bottom: 30px;
        margin-bottom: 30px;
        font-size: 28px;
        color: #A0ACB5;
        background-color: #FAFAFE;
        border-radius: 20px;

        .item-hd {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 96px;
            padding: 0 20px;
            margin-bottom: 30px;
            font-size: 26px;
            border-bottom: 2px solid #EBEBEB;
        }

        .item-status {
            font-size: 28px;
        }

        .item-ct {
            margin-top: 20px;
            padding: 0 20px;

            >span:nth-of-type(2) {
                color: #646566;
                margin-left: 40px;
                overflow-wrap: break-word;
            }
        }

        .item-btn-box {
            display: flex;
            justify-content: flex-end;
            padding: 0 20px;
        }

        .item-btn {
            width: 172px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            border: 2px solid #A0ACB5;
            border-radius: 44px;
        }
    }
</style>
